// Voeg hier je eigen custom JavaScript toe. Let op: Gebruik geen jQuery, maar vanilla JavaScript.
if (document.readyState !== 'loading') {
    initUpdateToday();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        initUpdateToday();
    });
}

// Fix for datepicker taal:
if (typeof flatpickr != "undefined") {
    const dutch = require("./lib/flatpickr-nl").default.nl;
    flatpickr.localize(dutch);
}

function initUpdateToday() {
    // Search and filter query watcher:
    if (window.searchAndFilter && window.searchAndFilter.frontend) {
        const query1 = window.searchAndFilter.frontend.queries.get(1); // Filmladder
        const query2 = window.searchAndFilter.frontend.queries.get(2); // Verwacht overzicht
        const query4 = window.searchAndFilter.frontend.queries.get(4); // Filmladder mobiel

        if (query1) {
            updateDateText(null, '_dag');
            // Luister naar het einde van de update
            query1.on('get-results/finish', function () {
                console.log("Finished getting results (q1), updating date text.");
                // Haal targets opnieuw op omdat de DOM na AJAX is ververst
                const targets = document.querySelectorAll('.today_text');
                updateDateText(targets, '_dag');
                removeCustomFilters(); // remove custom filter active state
            });
        } else if (query2) {
            updateDateText(null, '_premiere_date');
            // Luister naar het einde van de update
            query2.on('get-results/finish', function () {
                console.log("Finished getting results (q2), updating date text.");
                // Haal targets opnieuw op omdat de DOM na AJAX is ververst
                const targets = document.querySelectorAll('.today_text');
                updateDateText(targets, '_premiere_date');
                removeCustomFilters(); // remove custom filter active state
            });
        } else if (query4) {
            updateDateText(null, '_dag');
            // Luister naar het einde van de update
            query4.on('get-results/finish', function () {
                console.log("Finished getting results (q4), updating date text.");
                // Haal targets opnieuw op omdat de DOM na AJAX is ververst
                const targets = document.querySelectorAll('.today_text');
                updateDateText(targets, '_dag');
                removeCustomFilters(); // remove custom filter active state
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const openBtn = document.querySelector(".mobile-menu-special");
    const closeBtn = document.querySelector(".close-menu-special");
    const menu = document.querySelector(".extra-mobile-menu");

    if (openBtn && closeBtn && menu) {
        // Open menu
        openBtn.addEventListener("click", function () {
            menu.classList.add("active-menu");
        });

        // Sluit menu
        closeBtn.addEventListener("click", function () {
            menu.classList.remove("active-menu");
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const target = document.querySelector('.movie-ladder');

    document.addEventListener('click', (e) => {
        const button = e.target.closest('.ticket-button');

        if (!button || !target) return;

        e.preventDefault();

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
});


// Functie om de datum tekst te updaten
function updateDateText(targets, paramKey) {
    // console.log('updateDateText');
    // console.log(targets);

    // Haal targets op als ze niet worden meegegeven of null zijn
    if (!targets || targets.length === 0) {
        targets = document.querySelectorAll('.today_text');
    }

    if (!targets || targets.length === 0) {
        return;
    }

    // 1. Haal de URL parameters op
    const urlParams = new URLSearchParams(window.location.search);
    const dagParam = urlParams.get(paramKey) || urlParams.get('_dag');

    let targetDate;

    // 2. Bepaal welke datum we gebruiken
    if (dagParam) {
        // S&F gebruikt vaak YYYY-MM-DD of YYYYMMDD. 
        // We zorgen dat JS het begrijpt (indien YYYYMMDD, voeg streepjes toe)
        let dateString = dagParam;
        if (dateString.length === 8 && !dateString.includes('-')) {
            dateString = dateString.slice(0, 4) + '-' + dateString.slice(4, 6) + '-' + dateString.slice(6, 8);
        }
        targetDate = new Date(dateString);
    } else {
        targetDate = new Date();
    }

    // 3. Formatteer naar Nederlands: "woensdag 4 februari 2026"
    const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
    let formattedDate = new Intl.DateTimeFormat('nl-NL', options).format(targetDate);

    // Optioneel: Eerste letter hoofdletter maken (JS geeft vaak kleine letters voor dagen/maanden)
    formattedDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

    // 4. Update de tekst in alle HTML elementen
    targets.forEach(function (target) {
        target.textContent = formattedDate;
    });
}


function removeCustomFilters(params) {
    let atButtons = document.getElementsByClassName('at-filter-button') ?? null;
    if (atButtons.length) {
        Array.from(atButtons).forEach((btn) => {
            btn.classList.remove('at-button-active');
            btn.classList.add('at-button-inactive');
        });
    }
}

// Fallback voor pagina transities:
// window.addEventListener('pageshow', function (event) {
//     if (event.persisted) {
//         window.location.reload();
//     }
// });